import React, { useContext, useMemo, useState } from 'react';
import { MainContext } from '../../context/MainContext';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';

import DynamicSelect from '../resources/DynamicSelect';
import * as Constants from '../../components/api/constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Tooltip from '@mui/material/Tooltip';

const clmtData = [];
{
  let a = 10;
  let counter = 1;
  while (a <= 60) {
    clmtData.push({ id: counter, name: a });
    a++;
    counter++;
  }
}

const lshdData = [];
{
  let a = 1;
  let counter = 1;
  while (a <= 7) {
    lshdData.push({ id: counter, name: a });
    a++;
    counter++;
  }
}

const fcycleData = [
  { id: '1', name: '1' },
  { id: '2', name: '2' },
  { id: '3', name: '3' },
  { id: '4', name: '4' },
  { id: '5', name: '6' },
  { id: '6', name: '8' },
  { id: '7', name: '12' },
  { id: '8', name: '24' },
];

const veleData = [
  { id: '1', name: 'On Off' },
  { id: '2', name: 'STEP' },
  { id: '3', name: 'VARI' },
];

const vmaxData = [];
{
  let a = 3;
  let counter = 1;
  while (a <= 30) {
    vmaxData.push({ id: counter, name: a });
    a++;
    counter++;
  }
}

const gasData = [
  { id: '1', name: '0 = Norm' },
  { id: '2', name: '1 = 10 min cool down' },
];

const prmeData = [
  { id: '1', name: '10 second filt' },
  { id: '2', name: '2 minute filt' },
  { id: '3', name: '2 minute all' },
  { id: '4', name: '4 minute all' },
];

const onoffData = [
  { id: '1', name: 'On' },
  { id: '2', name: 'Off' },
];

const tadjData = [];
{
  let a = -2.0;
  let counter = 1;
  while (a <= 2.1) {
    tadjData.push({ id: counter, name: a.toFixed(1) });
    a = parseFloat((a + 0.1).toFixed(1));
    counter++;
  }
}

const llmData = [];
{
  let a = 1;
  let counter = 1;
  while (a <= 5) {
    llmData.push({ id: counter, name: a });
    a++;
    counter++;
  }
}

const unitData = [
  { id: '1', name: '°C' },
  { id: '2', name: '°F' },
];

const ahysData = [];
{
  let a = 0;
  let counter = 1;
  while (a <= 200) {
    ahysData.push({ id: counter, name: a });
    a += 10;
    counter++;
  }
}

const omaxData = [];
{
  let a = 0;
  let counter = 0;
  while (a <= 24) {
    omaxData.push({ id: counter, name: a });
    a++;
    counter++;
  }
}

const serData = [];
{
  serData.push({ id: 1, name: '0 = disabled' });
  serData.push({ id: 2, name: '1 wks' });
  let a = 2;
  let counter = 3;
  while (a <= 52) {
    serData.push({ id: counter, name: a });
    a++;
    counter++;
  }
}

const thysData = [];
{
  let a = 0.2;
  let counter = 0.1;
  while (a <= 2.0) {
    thysData.push({
      id: counter.toFixed(1),
      name: a.toFixed(1),
    });
    a = parseFloat((a + 0.1).toFixed(1));
    counter++;
  }
}

const dbgnData = [];
{
  let a = 10;
  let counter = 1;
  while (a >= -20) {
    dbgnData.push({ id: counter, name: a });
    a--;
    counter++;
  }
}

const dendData = [];
{
  let a = 5;
  let counter = 1;
  while (a <= 45) {
    dendData.push({ id: counter, name: a });
    a++;
    counter++;
  }
}

const dcmpData = [];
{
  let a = 20;
  let counter = 1;
  while (a <= 150) {
    dcmpData.push({ id: counter, name: a });
    a++;
    counter++;
  }
}

const dmaxData = [];
{
  let a = 1;
  let counter = 1;
  while (a <= 15) {
    dmaxData.push({ id: counter, name: a });
    a++;
    counter++;
  }
}

const cmaxData = [];
{
  let a = 70;
  let counter = 1;
  while (a <= 110) {
    cmaxData.push({ id: counter, name: a });
    a++;
    counter++;
  }
}

const pminData = [];
{
  let a = 20;
  let counter = 1;
  while (a <= 100) {
    pminData.push({ id: counter, name: a });
    a++;
    counter++;
  }
}

const pmaxData = [];
{
  let a = 50;
  let counter = 1;
  while (a <= 100) {
    pmaxData.push({ id: counter, name: a });
    a++;
    counter++;
  }
}

const OEM_MENU_TOOLTIPS = {
  'C.LMT': 'Current limit',
  'L.SHD': 'Load Shed Count',
  SANI: 'Sanitiser with spa use',
  'C.JET': 'Circ pump with jet',
  'F.CYC': 'Hrs between Filtration Cycles',
  'V.ELE': 'Variable element mode',
  'V.MAX': 'Variable element max current',
  GAS: '10m run after heating',
  PRME: 'Priming Cycle Length',
  'H.USE': 'Heat pump off with use',
  'T.ADJ': 'Temperature Adjust',
  '1.LLM': 'Load Limit Phase 1',
  '2.LLM': 'Load Limit Phase 2',
  '3.LLM': 'Load Limit Phase 3',
  UNIT: 'Temperature Units',
  'A.HYS': 'Adaptive hysteresis',
  'O.MAX': 'Ozone Maximum',
  'C.24': '24hr circ pump',
  '1.SER': 'Service Timer 1 (Check water chemistry)',
  '2.SER': 'Service Timer 2 (Service filters)',
  '3.SER': 'Service Timer 3 (Service spa)',
  'T.HYS': 'Target hysteresis',
  'D.BGN': 'Defrost begin temp',
  'D.END': 'Defrost end Temp',
  'D.CMP': 'Compressor runtime before defrost',
  'D.MAX': 'Defrost maximum runtime',
  'D.ELE': 'Defrost element engage temp',
  'D.PMP': 'Freeze protect pump engage temp',
  'C.MAX': 'Compressor maximum temp',
  'P.MIN': 'Variable pump minimum speed',
  'P.FLT': 'Variable pump filtration speed',
  'P.HTR': 'Variable pump heater speed',
  'P.MAX': 'Variable pump maximum speed',
};

export default function EEPROMOEMMenu() {
  const { state } = useContext(MainContext);
  const r3 = state.R3.split(',');
  const r6 = state.R6.split(',');
  const r7 = state.R7.split(',');
  const re = state.RE.split(',');
  const deviceId = state.selectedDevice;

  const [selectedValues, setSelectedValues] = useState({});

  const handleSelectChange = (key, value) => {
    setSelectedValues((prev) => ({ ...prev, [key]: value }));
  };

  const getCommandValue = (rowKey, value) => {
    if (value === undefined || value === null || value === '') return '';
    return String(value);
  };

  const sendCommand = (command, value) => {
    if (value === undefined || value === null || value === '') return;

    fetch(Constants.baseURL + Constants.apiSendCommand, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        DeviceId: deviceId,
        Command: command,
        Value: value.toString(),
      }),
      credentials: 'include',
    })
      .then((response) => {
        if (response.ok) {
          toast.success('Command sent successfully. Refreshing...', {
            position: 'top-right',
            autoClose: 10000,
          });

          setTimeout(() => state.refreshDeviceRF(deviceId), 6000);
          setTimeout(() => state.getUserDeviceRf(deviceId), 12000);
        } else {
          toast.error('Send failed. Please try again', {
            position: 'top-right',
            autoClose: 5000,
          });
        }
      })
      .catch((err) => console.log('request failed', err));
  };

  const group1Rows = useMemo(
    () => [
      {
        key: 'clmt',
        section: 'OEM Settings A',
        label: 'C.LMT',
        current: r3[1],
        options: clmtData,
        command: 'clmt',
      },
      {
        key: 'lshd',
        section: 'OEM Settings A',
        label: 'L.SHD',
        current: r3[17],
        options: lshdData,
        command: 'lshd',
      },
      {
        key: 'sani',
        section: 'OEM Settings A',
        label: 'SANI',
        current: r7[3] === '1' ? 'Off' : 'On',
        options: onoffData,
        command: 'sani',
      },
      {
        key: 'cjet',
        section: 'OEM Settings A',
        label: 'C.JET',
        current: r7[6] === '1' ? 'Off' : 'On',
        options: onoffData,
        command: 'cjet',
      },
      {
        key: 'fcyc',
        section: 'OEM Settings A',
        label: 'F.CYC',
        current: r6[7],
        options: fcycleData,
        command: 'fcyc',
      },
      {
        key: 'vele',
        section: 'OEM Settings A',
        label: 'V.ELE',
        current:
          r7[7] === '0'
            ? 'On/Off'
            : r7[7] === '1'
              ? 'Step'
              : r7[7] === '2'
                ? 'Vari'
                : 'N/A',
        options: veleData,
        command: 'vele',
      },
      {
        key: 'vmax',
        section: 'OEM Settings A',
        label: 'V.MAX',
        current: r7[22],
        options: vmaxData,
        command: 'vmax',
      },
      {
        key: 'gas',
        section: 'OEM Settings A',
        label: 'GAS',
        current: r6[27],
        options: gasData,
        command: 'gas',
      },
      {
        key: 'prme',
        section: 'OEM Settings A',
        label: 'PRME',
        current:
          r6[24] === '0'
            ? '10secF'
            : r6[24] === '1'
              ? '2minF'
              : r6[24] === '2'
                ? '2minA'
                : r6[24] === '3'
                  ? '4minA'
                  : 'N/A',
        options: prmeData,
        command: 'prme',
      },
      {
        key: 'huse',
        section: 'OEM Settings A',
        label: 'H.USE',
        current: r7[24] === '1' ? 'Off' : 'On',
        options: onoffData,
        command: 'huse',
      },
      {
        key: 'tadj',
        section: 'OEM Settings A',
        label: 'T.ADJ',
        current: (Number(r3[27]) / 10).toFixed(1),
        options: tadjData,
        command: 'tadj',
      },
      {
        key: 'llm1',
        section: 'OEM Settings A',
        label: '1.LLM',
        current: r3[3],
        options: llmData,
        command: '1llm',
      },
      {
        key: 'llm2',
        section: 'OEM Settings A',
        label: '2.LLM',
        current: r3[4],
        options: llmData,
        command: '2llm',
      },
      {
        key: 'llm3',
        section: 'OEM Settings A',
        label: '3.LLM',
        current: r3[5],
        options: llmData,
        command: '3llm',
      },
      {
        key: 'unit',
        section: 'OEM Settings A',
        label: 'UNIT',
        current: r7[2] === '1' ? '°F' : '°C',
        options: unitData,
        command: 'unit',
      },
      {
        key: 'ahys',
        section: 'OEM Settings A',
        label: 'A.HYS',
        current: (Number(r7[23]) / 10).toFixed(1),
        options: ahysData,
        command: 'ahys',
      },
      {
        key: 'omax',
        section: 'OEM Settings A',
        label: 'O.MAX',
        current: r7[4],
        options: omaxData,
        command: 'omax',
      },
    ],
    [r3, r6, r7]
  );

  const group2Rows = useMemo(
    () => [
      {
        key: 'c24',
        section: 'OEM Settings B',
        label: 'C.24',
        current: r7[5] === '1' ? 'Off' : 'On',
        options: onoffData,
        command: 'c24',
      },
      {
        key: '1ser',
        section: 'OEM Settings B',
        label: '1.SER',
        current: r7[19],
        options: serData,
        command: '1ser',
      },
      {
        key: '2ser',
        section: 'OEM Settings B',
        label: '2.SER',
        current: r7[20],
        options: serData,
        command: '2ser',
      },
      {
        key: '3ser',
        section: 'OEM Settings B',
        label: '3.SER',
        current: r7[21],
        options: serData,
        command: '3ser',
      },
      {
        key: 'thys',
        section: 'OEM Settings B',
        label: 'T.HYS',
        current: (Number(r7[31]) / 10).toFixed(1) + ' °C',
        options: thysData,
        command: 'thys',
      },
      {
        key: 'dbgn',
        section: 'OEM Settings B',
        label: 'D.BGN',
        current: re[25],
        options: dbgnData,
        command: 'dbgn',
      },
      {
        key: 'dend',
        section: 'OEM Settings B',
        label: 'D.END',
        current: re[26],
        options: dendData,
        command: 'dend',
      },
      {
        key: 'dcmp',
        section: 'OEM Settings B',
        label: 'D.CMP',
        current: re[27],
        options: dcmpData,
        command: 'dcmp',
      },
      {
        key: 'dmax',
        section: 'OEM Settings B',
        label: 'D.MAX',
        current: re[28],
        options: dmaxData,
        command: 'dmax',
      },
      {
        key: 'dele',
        section: 'OEM Settings B',
        label: 'D.ELE',
        current: re[29],
        options: dbgnData,
        command: 'dele',
      },
      {
        key: 'dpmp',
        section: 'OEM Settings B',
        label: 'D.PMP',
        current: re[30],
        options: dbgnData,
        command: 'dpmp',
      },
      {
        key: 'cmax',
        section: 'OEM Settings B',
        label: 'C.MAX',
        current: re[39] === undefined ? '...' : re[39],
        options: cmaxData,
        command: 'cmax',
      },
      {
        key: 'pmin',
        section: 'OEM Settings B',
        label: 'P.MIN',
        current: r7[27],
        options: pminData,
        command: 'pmin',
      },
      {
        key: 'pflt',
        section: 'OEM Settings B',
        label: 'P.FLT',
        current: r7[28],
        options: pminData,
        command: 'pflt',
      },
      {
        key: 'phtr',
        section: 'OEM Settings B',
        label: 'P.HTR',
        current: r7[29],
        options: pminData,
        command: 'phtr',
      },
      {
        key: 'pmax',
        section: 'OEM Settings B',
        label: 'P.MAX',
        current: r7[30],
        options: pmaxData,
        command: 'pmax',
      },
    ],
    [r7, re]
  );

  const rows = useMemo(() => [...group1Rows, ...group2Rows], [group1Rows, group2Rows]);

  const onSend = (row) => {
    const raw = selectedValues[row.key];
    const value = getCommandValue(row.key, raw);
    if (!value) return;
    sendCommand(row.command, value);
  };

  return (
    <>
      <ToastContainer />

      <Typography
        component="h2"
        variant="h6"
        color="white"
        sx={{ fontWeight: 600, mb: 2 }}
      >
        OEM Menu
      </Typography>

      <Grid container spacing={2}>
        {rows.map((row) => {
          const hasSelection =
            selectedValues[row.key] !== undefined && selectedValues[row.key] !== '';

          return (
            <Grid item xs={12} sm={6} md={4} lg={3} key={row.key}>
              <Paper
                sx={{
                  p: 2,
                  borderRadius: 2,
                  bgcolor: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1.2,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ color: 'white', fontWeight: 600, fontSize: 14 }}
                  >
                    {row.label}
                  </Typography>

                  {OEM_MENU_TOOLTIPS[row.label] && (
                    <Typography
                      sx={{
                        fontSize: 13,
                        color: 'white',
                        lineHeight: 1.2,
                        whiteSpace: 'normal',
                        wordBreak: 'break-word', 
                        ml: 1,
                        textAlign: 'right', 
                      }}
                    >
                      {OEM_MENU_TOOLTIPS[row.label]}
                    </Typography>
                  )}

                </Box>

                <Typography
                  variant="caption"
                  sx={{
                    fontSize: 13,
                    color: 'text.disabled',
                  }}
                >
                  {row.current ?? 'N/A'}
                </Typography>

                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    alignItems: 'stretch',
                    flexDirection: { xs: 'column', md: 'row' },
                    width: '100%',
                    minWidth: 0,
                    mt: 0.5,

                    '--control-h': { xs: '44px', md: '44px' },

                    '& .MuiInputBase-root': { height: 'var(--control-h)' },
                    '& .MuiSelect-select': {
                      height: 'var(--control-h)',
                      display: 'flex',
                      alignItems: 'center',
                      paddingTop: 0,
                      paddingBottom: 0,
                    },
                    '& .MuiFormControl-root': { width: '100%', minWidth: 0 },
                  }}
                >
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <DynamicSelect
                      arrayOfData={row.options}
                      onSelectChange={(val) => handleSelectChange(row.key, val)}
                      id={row.key}
                      name=""
                    />
                  </Box>

                  {hasSelection && (
                    <Button
                      onClick={() => onSend(row)}
                      variant="outlined"
                      size="small"
                      sx={{
                        height: 'var(--control-h)',
                        minHeight: 'var(--control-h)',
                        textTransform: 'none',
                        fontWeight: 600,
                        borderColor: 'rgba(255,255,255,0.3)',
                        color: 'white',
                        px: 1.5,
                        width: { xs: '100%', md: 'auto' },
                        whiteSpace: 'nowrap',
                        '&:hover': {
                          borderColor: 'white',
                          backgroundColor: 'rgba(255,255,255,0.08)',
                        },
                      }}
                    >
                      Send
                    </Button>
                  )}
                </Box>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
